const escapeHtml = function (value) {
  return String(value === null || value === undefined ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

const isExternalHref = function (href) {
  const text = String(href || '').trim()
  if (!text) return false
  if (/^\/\//.test(text)) return true
  return /^[a-z][a-z0-9+.-]*:/i.test(text)
}

const normalizeDocPath = function (value) {
  const text = String(value === null || value === undefined ? '' : value).trim().replace(/\\/g, '/')
  const parts = text.split('/')
  const out = []
  for (let i = 0; i < parts.length; i += 1) {
    const part = String(parts[i] || '').trim()
    if (!part || part === '.') continue
    if (part === '..') {
      if (out.length) out.pop()
      continue
    }
    out.push(part)
  }
  return out.join('/')
}

const stripHrefQueryHash = function (href) {
  const text = String(href || '').trim()
  const noHash = text.split('#')[0] || ''
  return noHash.split('?')[0] || ''
}

const resolveReadmeHrefToDocPath = function (href, currentPagePath) {
  const raw = stripHrefQueryHash(href)
  if (!raw) return ''
  if (isExternalHref(raw)) return ''
  const normalizedCurrent = normalizeDocPath(currentPagePath)
  const cleanHref = normalizeDocPath(raw)
  if (!cleanHref) return ''
  if (raw.startsWith('/')) return cleanHref
  const slashIdx = normalizedCurrent.lastIndexOf('/')
  const currentDir = slashIdx >= 0 ? normalizedCurrent.slice(0, slashIdx + 1) : ''
  return normalizeDocPath(currentDir + cleanHref)
}

const mdInline = function (value) {
  let safe = escapeHtml(value)
  safe = safe.replace(/`([^`]+)`/g, '<code>$1</code>')
  safe = safe.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
  safe = safe.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function (_match, label, href) {
    const linkHref = String(href || '').trim()
    if (isExternalHref(linkHref)) {
      return '<a href="' + linkHref + '" target="_blank" rel="noopener noreferrer">' + label + '</a>'
    }
    return '<a href="' + linkHref + '">' + label + '</a>'
  })
  return safe
}

const renderMarkdownToHtml = function (markdownText) {
  const lines = String(markdownText || '').replace(/\r\n/g, '\n').split('\n')
  let html = ''
  let inCode = false
  let listType = ''
  const closeList = function () {
    if (!listType) return
    html += listType === 'ol' ? '</ol>' : '</ul>'
    listType = ''
  }
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]
    if (/^```/.test(line.trim())) {
      closeList()
      if (inCode) {
        html += '</code></pre>'
        inCode = false
      } else {
        html += '<pre class="portal-readme-code"><code>'
        inCode = true
      }
      continue
    }
    if (inCode) {
      html += escapeHtml(line) + '\n'
      continue
    }
    const headingMatch = line.match(/^(#{1,6})\s+(.+)$/)
    if (headingMatch) {
      closeList()
      const level = headingMatch[1].length
      html += '<h' + level + '>' + mdInline(headingMatch[2]) + '</h' + level + '>'
      continue
    }
    const ulMatch = line.match(/^[-*]\s+(.+)$/)
    if (ulMatch) {
      if (listType !== 'ul') {
        closeList()
        html += '<ul>'
        listType = 'ul'
      }
      html += '<li>' + mdInline(ulMatch[1]) + '</li>'
      continue
    }
    const olMatch = line.match(/^\d+\.\s+(.+)$/)
    if (olMatch) {
      if (listType !== 'ol') {
        closeList()
        html += '<ol>'
        listType = 'ol'
      }
      html += '<li>' + mdInline(olMatch[1]) + '</li>'
      continue
    }
    if (!line.trim()) {
      closeList()
      html += '<div class="portal-readme-spacer"></div>'
      continue
    }
    closeList()
    html += '<p>' + mdInline(line) + '</p>'
  }
  closeList()
  if (inCode) html += '</code></pre>'
  return html
}

const renderReadmePanel = function ($container, payload, options) {
  const opts = (options && typeof options === 'object') ? options : {}
  const $ = (typeof opts.$ === 'function')
    ? opts.$
    : ((typeof window !== 'undefined' && typeof window.jQuery === 'function') ? window.jQuery : null)
  const t = (typeof opts.t === 'function')
    ? opts.t
    : function (_key, fallback) { return String(fallback || _key || '') }
  if (!$ || !$container || typeof $container.empty !== 'function') return
  $container.empty()
  const pages = Array.isArray(payload && payload.pages) ? payload.pages : []
  if (!pages.length) {
    $container.append($('<div class="alert alert-warning mb-0"></div>').text(t('readme.unavailable')))
    return
  }
  const pageIndexByPath = {}
  const pageIndexByBasename = {}
  pages.forEach((page, index) => {
    const normalizedPath = normalizeDocPath(page && page.path)
    if (normalizedPath) {
      const pathKey = normalizedPath.toLowerCase()
      if (pageIndexByPath[pathKey] === undefined) pageIndexByPath[pathKey] = index
      const baseName = normalizedPath.split('/').pop() || ''
      if (baseName) {
        const baseKey = baseName.toLowerCase()
        if (pageIndexByBasename[baseKey] === undefined) pageIndexByBasename[baseKey] = index
      }
    }
  })
  let pageIndex = 0
  const $wrapper = $('<div class="portal-readme-wrap"></div>')
  const $nav = $('<div class="d-flex align-items-center justify-content-between gap-2 mb-2"></div>')
  const $prev = $('<button type="button" class="btn btn-sm btn-outline-secondary"></button>').text(t('common.previous'))
  const $next = $('<button type="button" class="btn btn-sm btn-outline-secondary"></button>').text(t('common.next'))
  const $title = $('<div class="fw-semibold flex-grow-1 text-center"></div>')
  const $path = $('<div class="small text-body-secondary mb-2"></div>')
  const $content = $('<div class="portal-readme-content border rounded p-3 bg-body-tertiary"></div>')

  $nav.append($prev).append($title).append($next)
  $wrapper.append($nav).append($path).append($content)
  $container.append($wrapper)

  const resolveTargetPageIndex = function (href) {
    const currentPath = String((pages[pageIndex] && pages[pageIndex].path) || '')
    const resolvedPath = resolveReadmeHrefToDocPath(href, currentPath)
    if (!resolvedPath) return -1
    const byPath = pageIndexByPath[String(resolvedPath || '').toLowerCase()]
    if (byPath !== undefined) return byPath
    const baseName = String(resolvedPath || '').split('/').pop() || ''
    if (!baseName) return -1
    const byBaseName = pageIndexByBasename[baseName.toLowerCase()]
    if (byBaseName !== undefined) return byBaseName
    return -1
  }

  const renderPage = function () {
    const page = pages[pageIndex] || {}
    $title.text(String(page.title || 'README') + ' (' + (pageIndex + 1) + '/' + pages.length + ')')
    $path.text(String(page.path || ''))
    $content.html(renderMarkdownToHtml(page.content || ''))
    $prev.prop('disabled', pageIndex <= 0)
    $next.prop('disabled', pageIndex >= (pages.length - 1))
  }

  $content.on('click', 'a', function (event) {
    const $link = $(this)
    const href = String($link.attr('href') || '').trim()
    if (!href) return
    const targetIndex = resolveTargetPageIndex(href)
    if (targetIndex >= 0) {
      event.preventDefault()
      if (pageIndex !== targetIndex) {
        pageIndex = targetIndex
        renderPage()
      }
      return
    }
    if (!isExternalHref(href)) {
      event.preventDefault()
    }
  })

  $prev.on('click', function () {
    if (pageIndex <= 0) return
    pageIndex -= 1
    renderPage()
  })
  $next.on('click', function () {
    if (pageIndex >= (pages.length - 1)) return
    pageIndex += 1
    renderPage()
  })
  renderPage()
}

export {
  escapeHtml,
  mdInline,
  renderMarkdownToHtml,
  renderReadmePanel
}
